import baseApiMethod from "./baseApiMethod";

const commentApi = {};

commentApi.getComments = ({ id }) => baseApiMethod(null, `comments?ObjectId=${id}`, "get");
commentApi.addComment = (data) => baseApiMethod(data, "comments", "post");

export default commentApi;
